<template>
  <div class="advertise">
    <v-row>
      <v-col cols="12" md="6" v-for="(item, index) in advertises" :key="index">
        <a :href="item.url">
          <v-img :src="item.imgUrl"></v-img>
        </a>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "AD",
  data() {
    return {
      advertises: []
    };
  },
  created() {
    this.handleGetAdvertise();
  },
  methods: {
    handleGetAdvertise() {
      this.$api.get("advertise").then((res) => {
        this.advertises = res.data.advertise;
      });
    }
  }
};
</script>
